const getVideoDuration = async (url?: string): Promise<number> => {
  if (!url) return 0;

  return new Promise((resolve) => {
    const video = document.createElement('video');

    let isDone = false;

    const done = (duration: number) => {
      if (isDone) return;
      isDone = true;
      video.src = '';
      resolve(duration);
    };

    video.preload = 'metadata';
    video.muted = true;
    video.playsInline = true;

    video.src = url;
    video.load();

    video.onloadedmetadata = () => {
      done(Math.ceil(video.duration || 60));
    };

    video.onerror = () => {
      done(60);
    };

    setTimeout(() => {
      done(60);
    }, 3000);
  });
};

export default getVideoDuration;